
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BusinessGroupDetailsResponse, BusinessGroupsService } from '@src/app/shared/backend/clients';
import { ConfirmationService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Actions } from '@src/app/shared/backend/auth/Action';
import { DialogReasonComponent } from '@src/app/shared/components/dialog-reason/dialog-reason.component';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-view-business-group',
    templateUrl: './view-business-group.component.html',
    styleUrl: './view-business-group.component.scss',
    host: {
        class: 'app-view-business-group'
    },
    providers: [ConfirmationService],
    standalone: false
})
export class ViewBusinessGroupComponent  extends BaseViewComponent implements OnInit {

  @ViewChild('dialog') dialog: DialogReasonComponent | undefined;

  delete: boolean = false;
  allowModifyBusinessGroup: boolean = false;
  businessGroupId: number = 0;
  businessGroup: BusinessGroupDetailsResponse = {
    id: 0,
    name: '',
    code: ''
  };

  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private businessGroupsService: BusinessGroupsService) {
      super();
  }

  override async setData(data: any) {

    if (!data) {
      return;
    }
    this.businessGroupId = data;
    await this.get();

  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params.subscribe(async params => {
      this.businessGroupId = params['businessGroupId'];
      await this.get();
    })

  }

  override async get() {
    try {
      this.businessGroup = await firstValueFrom(this.businessGroupsService.apiBusinessGroupsDetailsIdGet(this.businessGroupId));

      this.delete = await this.permissionService.hasActionPermissions(Actions.delete);
      this.allowModifyBusinessGroup = await this.permissionService.hasActionPermissions(Actions.modify_business_groups);

    } catch (error) {
      console.log('Error fetching businessGroup data:', error);
    }
  }

  goToEditBusinessGroup() {
    this.router.navigate([`/business-groups/${this.businessGroupId}/edit`]);
  }

  async showDeleteDialog(): Promise<void> {
    const deleteCheckResponses = await firstValueFrom(this.businessGroupsService.apiBusinessGroupsDeleteCheckBatchPost([this.businessGroupId]));

    this.dialog?.show(deleteCheckResponses);
  }

  async deleteBusinessGroup(doDelete: boolean): Promise<void> {
    if (doDelete) {
      await firstValueFrom(this.businessGroupsService.apiBusinessGroupsDeleteIdDelete(this.businessGroupId));
      this.router.navigate([`/business-groups`]);
    }
  }
}
